<template>
  <div class="mob-inject">
    <template v-if="homeShow">
       <!-- 場景選擇 -->
        <scene-select
                :no-bg="false"
                @changeScene="loadScene"
                :sel-scene="selectScene"
        ></scene-select>
        <div class="add-box" v-if="hotspotObj && Object.keys(hotspotObj).length === 0">
          <div class="add-inject" @click="addHotspot">{{$t('edit.walk.addWalk')}}</div>
        </div>
        <div class="follow-old" v-else>
          <!-- <div class="options" v-if="currHotId">
            <div class="options-btn" @click="editItem">{{$t('actionTitles.edit')}}</div>
            <div class="options-btn" @click="deleteItem">{{$t('actionTitles.delete')}}</div>
          </div> -->
          <div class="base-container">
            <div class="list-container">
              <div class="oild-list">
                <TPItem
                  v-for="(value, k) in hotspotObj"
                  :key="k"
                  valueKey="hotspot_id"
                  :itemObj="value"
                  :selectedId="currHotId"
                  :is-icon="false"
                  @click.native="onClickItem(value)"
                ></TPItem>
              </div>
            </div>
            <div class="adds" @click="addHotspot" v-show="showAddBtn">
                <div>
                    <img src="../../assets/img/mob_add_scene.png"/>
                    <h5>{{$t('edit.walk.addWalk')}}</h5>
                </div>
            </div>
            <!-- <div class="add-new" @click="addHotspot">
              <div class="text">{{$t('edit.walk.addWalk').slice(0,2)}}</div>
              <div class="text">{{$t('edit.walk.addWalk').slice(-2)}}</div>
            </div> -->
           <!-- 編輯漫遊 -->
        <edit-options
                v-if="editWalkVisible"
                :options="options"
                @returnBack="closeOptions"
                @onclick="editOptions"
        ></edit-options>
          </div>
        </div>
    </template>
    <template v-if="sceneShow">
      <HotpScene
        :defaultValue="editTarget"
        @onClickBack="changeToShowHome"
        @saveDataToStore="saveDataToStore"
        @change="handleHotspotChange"
      ></HotpScene>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import HotpScene from "./component/HotpScene";
import Steps from "../Steps.vue";
import TextItem from "../TextItem";
import TPItem from "../TPItem";
import SceneSelect from "../scenes/SceneSelect";
import EditOptions from "../EditOptions";

export default {
  components: { HotpScene, TPItem, TextItem, Steps ,SceneSelect,EditOptions},
  data() {
    return {
      hotspotObj: {},
      homeShow: true,
      sceneShow: false,
      isAddNew: true,
      showAddPannel: false,
      editTarget: null,
      currHotId: "",
      currentTypeItem: {},
      editWalkVisible: false,
      selectScene:[],
      options:[
          {title: this.$t('actionTitles.edit'), src: require('../../assets/img/mob_create.png'), type: 'edit'},
          {title: this.$t('actionTitles.delete'), src: require('../../assets/img/mob_delete.png'), type: 'delete'},
        ],
      showAddBtn: true,
    };
  },
  watch: {
    currentScenesId:{
       handler(newVal){
      this.$set(this.selectScene, 0, newVal);
      this.handleInitListData();
       }
    },
  },
  created() {
    this.handleInitListData();
    this.selectScene[0] = this.currentScenesId;
  },
  computed: { ...mapGetters(["vrbase", "currentScenesId"]) },
  methods: {
    // 這裡過濾掉scene類型的數據
    handleInitListData() {
      const hotports = this.vrbase.scenes[this.currentScenesId].hotspot;
      let tempObj = {};
      for (let key in hotports) {
        if (hotports[key].type === "scene") {
          tempObj[key] = hotports[key];
        }
      }
      this.hotspotObj = tempObj;
    },
    addHotspot() {
      this.resetEditData();
      this.isAddNew = true;
      this.sceneShow = true;
      this.homeShow = false;
    },
    onClickItem(value) {
      this.showAddBtn = false;
      this.editWalkVisible = true;
      this.currHotId = value.hotspot_id;
      lookto(value.ath, value.atv);
      this.editTarget = value;
    },
    // onClickType(item) {
    //   this.currentTypeItem = item;
    // },
    resetEditData() {
      this.currHotId = "";
      this.editTarget = null;
      this.editWalkVisible = false;
    },
    onClickNext() {
      if (this.currentTypeItem.type) {
        this.changeToShowHome(this.currentTypeItem.type);
      } else {
        this.$message.error(this.$t('edit.editMessage.hotPSelect'))
      }
    },
    changeToShowHome() {
      this.sceneShow = false;
      this.homeShow = true;
    },
    saveDataToStore({ key, data }) {
      this.changeToShowHome();
      let vrbase = this.vrbase;
      this.$set(this.hotspotObj, key, data); // 更新本地
      vrbase.scenes[this.currentScenesId].hotspot[key] = data;
      this.$store.dispatch("setVRBase", vrbase);
      // this.showAddPannel = false; //增加數據後顯示增加的 數據
    },
    deleteItem() {
      const selectedItem = this.editTarget;
      let hotspot = this.vrbase.scenes[this.currentScenesId].hotspot;
      const _this = this;
      this.$confirm({
        title: _this.$t('edit.editMessage.title'),
        content: _this.$t('edit.editMessage.content'),
        okText: _this.$t('edit.editMessage.okText'),
        okType: "danger",
        cancelText: _this.$t('edit.editMessage.cancelText'),
        onOk() {
         _this.$delete(hotspot, selectedItem.hotspot_id);
          _this.$delete(_this.hotspotObj, selectedItem.hotspot_id);
          _this.$store.dispatch("setVRBase", _this.vrbase);
          removeHotspot(selectedItem.hotspot_id);
          _this.resetEditData()
        },
        onCancel() {
          console.log("取消");
        },
      });
    },
    editItem() {
      this.sceneShow = true;
      this.homeShow = false;
    },
    handleHotspotChange(val, oldVal) {
      setHotspot(val, oldVal);
    },
     loadScene(id){
      this.$store.dispatch("loadScene", id);
      this.closeOptions();
    },
    //關閉編輯
    closeOptions(){
      this.editWalkVisible = false
      this.currHotId = ''
      this.showAddBtn = true
    },
    //option的功能
    editOptions(type){
      if(type == 'edit'){
        this.editItem()
      }
      if(type == 'delete'){
        this.deleteItem()
      }
      this.editWalkVisible = false
      this.showAddBtn = true
    },
  },
};
</script>

<style lang="less" scoped>
.mob-inject{
    padding: 0 !important;
}
</style>
